import { render, staticRenderFns } from "./VideoItem.vue?vue&type=template&id=05e9db92&scoped=true&"
import script from "./VideoItem.vue?vue&type=script&lang=js&"
export * from "./VideoItem.vue?vue&type=script&lang=js&"
import style0 from "./VideoItem.vue?vue&type=style&index=0&lang=css&"
import style1 from "./VideoItem.vue?vue&type=style&index=1&id=05e9db92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e9db92",
  null
  
)

export default component.exports